import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/features/auth';
import { LoginPage } from '@/features/login';

/**
 * Rota pública `/login`. Se já autenticado, redireciona pro app —
 * evita user logado ficar olhando pra tela de login (UX óbvia).
 */
export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/app/dashboard' });
    }
  },
  component: LoginPage,
});
